import React from 'react';
import { useLocation } from 'react-use';
import { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { NextSeo } from 'next-seo';

import Layout from '@/components/Layout';
import Blog from '@/components/ReasonsForChoosing/Blog';
import Family from '@/components/ReasonsForChoosing/Family';
import InternationalCompetitiveness from '@/components/ReasonsForChoosing/InternationalCompetitiveness';
import Service from '@/components/ReasonsForChoosing/Service';
import Statistics from '@/components/ReasonsForChoosing/Statistics';
import StudyPlan from '@/components/ReasonsForChoosing/StudyPlan';
import Teachers from '@/components/ReasonsForChoosing/Teachers';

const StudentMessages = dynamic(() => import('@/components/ReasonsForChoosing/StudentMessages'), { ssr: false });

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'path', 'home', 'whyWukong'])),
    },
  };
};

const WhyChooseUs = () => {
  const { t } = useTranslation(['whyWukong', 'common']);
  const state = useLocation();

  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-选择悟空的理由-title'),
          description: t('common:seo-选择悟空的理由-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-选择悟空的理由-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-选择悟空的理由-title')}</title>
        <meta name="description" content={t('common:seo-选择悟空的理由-description')} />
        <meta name="keywords" content={t('common:seo-选择悟空的理由-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-选择悟空的理由-title')}
        />
      </Head>
      {/* 家庭展示 */}
      <Family />
      {/* 数据统计 */}
      <Statistics />
      {/* 国际竞争力 */}
      <InternationalCompetitiveness />
      {/* 教学团队 */}
      <Teachers />
      {/* 学生评价 */}
      <StudentMessages />
      {/* 学习计划 */}
      <StudyPlan />
      {/* 专属服务 */}
      <Service />
      {/* blog */}
      <Blog />
    </>
  );
};

export default WhyChooseUs;

WhyChooseUs.getLayout = (page: React.ReactElement) => <Layout tooterTheme="home">{page}</Layout>;
